import React from 'react'
import Footer from '../../../Components/Footer'
import Lpntable from './Components/Lpn-table'
import Header from '../../../Components/Header'

const AsnList = () => {
    return (
        <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
            <Header/>
            <Lpntable />
            {/* <Footer /> */}
        </div>
    )
}

export default AsnList